module.exports = __webpack_public_path__ + "media/favicon/mstile-150x150-0951e293.png";